<template>
    <div class="valorar-pedido-wrapper">
        <overlay :show="showAll" />
        <div :class="{ 'overlay-item': showAll }" class="valorar-pedido">
            <div class="valorar-pedido-btn-action" @click="toggleAll">
                Valora esta variedad
                <div class="pedido-id-icon-positioner">
                    <down-icon v-show="!showAll"></down-icon>
                    <up-icon v-show="showAll"></up-icon>
                </div>
            </div>
            <div class="star-rating-pos">
                <div @click="showAll = true">
                    <star-rating
                        :star-size="starSizeNumber"
                        :show-rating="false"
                        v-bind:min-rating="0"
                        v-model="rating"
                    ></star-rating>
                </div>
            </div>
            <div class="formulario" v-show="showAll">
                <div class="question">
                    Comparte la opinión de tu cultivo
                </div>
                <textarea
                    v-model="observations"
                    aria-label="Escribir comentario"
                    rows="3"
                    class="comentario-textarea form-control"
                    placeholder="Escribir comentario"
                ></textarea>
                <div class="question second-question">
                    Comparte una foto de tu cultivo
                </div>
                <b-form-file
                    v-model="image"
                    accept=".jpg, .jpeg"
                    placeholder="Elige una imagen o arrastrala aquí..."
                    browse-text="Buscar"
                    style="overflow: hidden"
                ></b-form-file>
                <p class="conditions">
                    Al enviar el formulario aceptas los
                    <a
                        class="form-terminos"
                        :href="route('info.terminos.condiciones')"
                        >términos y condiciones</a
                    >
                    y la
                    <a
                        class="form-terminos"
                        :href="route('info.politica.privacidad')"
                        >política de privacidad</a
                    >.
                </p>
                <b-form-checkbox
                    class="show-name-checkbox"
                    value="1"
                    unchecked-value="0"
                    v-model="mostrarNombre"
                >
                    Mostrar mi nombre en la valoración
                </b-form-checkbox>
                <div
                    class="valorar-pedido-submit-btn"
                    @click="submitValoracion"
                >
                    Enviar
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StarRating from "vue-star-rating";
import Overlay from "../../Overlay.vue";
import DownIcon from "./DownIcon";
import UpIcon from "./UpIcon";
export default {
    name: "ValorarVariedadBtn",
    components: { UpIcon, DownIcon, StarRating, Overlay },
    props: {
        pedidoLineId: {
            required: true
        },
        customType: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            starSizeNumber: 40,
            rating: 3,
            observations: "",
            image: null,
            voted: false,
            mostrarNombre: false,
            submitting: false,
            showAll: false
        };
    },
    computed: {},
    methods: {
        toggleAll() {
            this.showAll = !this.showAll;
        },
        submitValoracion() {
            if (this.submitting || this.voted) {
                return;
            }

            if (this.image) {
                if (this.image.size / 1024 > 2048) {
                    Vue.toasted.show("La imagen debe ser menor a 2 MB", {
                        type: "warning",
                        duration: 3000
                    });
                    return;
                }
            }

            this.submitting = true;

            let formData = new FormData();
            formData.append("id", this.pedidoLineId);
            formData.append("comment", this.observations);
            formData.append("show_name", this.mostrarNombre);
            formData.append("custom_type", this.customType ? 1 : 0);
            formData.append("rating", this.rating);
            if (this.image) {
                formData.append("image", this.image);
            }

            axios
                .post(
                    this.route("account.valoraciones.variedad.store"),
                    formData
                )
                .then(res => {
                    this.voted = true;
                    Vue.toasted.show(
                        "Valoración enviada. Tu opinión nos ayudará a mejorar para ofrecer el mejor servicio.",
                        {
                            type: "success",
                            duration: 3000
                        }
                    );
                    this.$emit("voted");
                })
                .catch(err => {
                    if (err.response.status === 422) {
                        Vue.toasted.show(
                            "Asegurate de contestar todos los campos",
                            {
                                type: "error",
                                duration: 3000
                            }
                        );
                    } else {
                        Vue.toasted.show(
                            "Error al intentar guardar la encuesta. Inténtalo más tarde.",
                            {
                                type: "error",
                                duration: 3000
                            }
                        );
                    }
                })
                .finally(() => {
                    this.submitting = false;
                });
        }
    }
};
</script>

<style scoped>
.valorar-pedido {
    display: block;
    width: 100%;
    border: 3px solid #f73863;
    position: relative;
    background-color: #fff;
}

.valorar-pedido-btn-action {
    cursor: pointer;
    text-decoration: none;
    position: relative;
    text-align: center;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.6;
    text-transform: none;
    vertical-align: middle;
    color: #f73863;
    transition: none;
    padding: 0.375rem 0.75rem;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.pedido-id-icon-positioner {
    position: absolute;
    right: 5%;
    top: 0;
    width: 1.4em;
    height: 100%;
    display: flex;
    align-items: center;
}

.pedido-btn img {
    width: 100%;
}

.formulario {
    position: absolute;
    width: calc(100% + 6px); /* Para arreglar los bordes */
    left: -3px; /* Para arreglar los bordes */
    background-color: #fff;
    padding: 0.375rem;
    border: 3px solid #f73863;
    border-top: 0;
    z-index: 100;
}

.star-rating-pos {
    display: flex;
    justify-content: center;
    padding-bottom: 1rem;
    padding-top: 0.625rem;
}

.question {
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.25rem;
}

.second-question {
    margin-top: 0.75rem;
}

.comentario-textarea {
    background-color: #f3f2f2;
    border-radius: 0;
    color: #818282;
    border-color: #818282;
}

.conditions {
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0;
}

.conditions a {
    color: #000000;
}

.valorar-pedido-submit-btn {
    background-color: #f73863;
    color: white;
    cursor: pointer;
    font-weight: bold;
    text-align: center;
    padding: 0.5rem;
}

.valorar-pedido-submit-btn:hover {
    background-color: #d72f54;
}

.show-name-checkbox {
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.show-name-checkbox {
    font-weight: bold;
}

hr {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
    width: 80%;
}

@media screen and (max-width: 575px) {
    .valorar-pedido {
        border-width: 1px;
    }

    .formulario {
        width: 100%;
        left: 0;
        border: 0;
        position: relative;
    }
}
</style>

<style>
.show-name-checkbox.custom-checkbox .custom-control-label::before {
    border-radius: 0;
    border: #000000 solid 1px;
}

.show-name-checkbox
    .custom-control-input:checked
    ~ .custom-control-label::before {
    background-color: #d72f54;
}
</style>
